import { render } from "./RatingsListScrum.vue?vue&type=template&id=ba027410&scoped=true"
import script from "./RatingsListScrum.vue?vue&type=script&lang=js"
export * from "./RatingsListScrum.vue?vue&type=script&lang=js"

import "./RatingsListScrum.vue?vue&type=style&index=0&id=ba027410&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba027410"]])

export default __exports__